export const URLS = {
  DEFAULT_PROXY_URL: 'https://proxy.scalar.com',
  PRIVACY_POLICY: 'https://scalar.com/legal/privacy-policy',
  TERMS_AND_CONDITIONS: 'https://scalar.com/legal/terms-and-conditions',
  AGENT_SCALAR_DOCUMENTATION: 'https://scalar.com/products/agent/getting-started',
  PROXY_SOURCE_CODE: 'https://github.com/scalar/scalar/tree/main/projects/proxy-scalar-com',
} as const
